/*!
 *   Copyright 2022-2023  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
:host {
  width: 100%;
  height: 100%;
  position: relative;
}
:host .discovery-tile {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:host .discovery-tile .tile-title {
  padding: 5px;
  margin: 0;
  flex-shrink: 1;
  text-align: center;
  color: var(--warp-view-font-color, #404040);
}
:host .discovery-tile .tile-desc {
  padding: 5px;
  margin: 0;
  flex-shrink: 1;
  text-align: center;
  color: var(--warp-view-font-color, #404040);
}
:host .discovery-tile .discovery-chart-wrapper {
  flex-grow: 4;
  cursor: auto;
  text-align: left;
  height: calc(100% - 20px);
  position: relative;
  width: 100%;
}